import { Company } from "../../models/company";
import { DomSanitizer } from "@angular/platform-browser";
import { CompanyService } from "../../services/company.service";
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    companies: Partial<Company>[];

    constructor(private companyService: CompanyService, 
        public sanitizer: DomSanitizer) {
        this.companyService.getPartialCompanies().then(
            res => {
                this.companies = res;
                this.SortCompaniesByPriority();
            }).catch(console.log);
    }

    SortCompaniesByPriority() {
        if (this.companies) {
            for (let i = 0; i < this.companies.length - 1; i++) {
                for (let j = i + 1; j < this.companies.length; j++) {
                    if (this.companies[i].priority > this.companies[j].priority) {
                        console.log(this.companies[i].priority);
                        [this.companies[i], this.companies[j]] = [this.companies[j], this.companies[i]];
                    }
                }
            }
        }
    }
    
    ngOnInit(): void {
    }
}
